import { TypeImage } from "@contentful/types";
import { Image } from "@yardzen/ui/components/image";

export function ImageCollectionGrid({
  images,
}: {
  images: TypeImage<"WITHOUT_UNRESOLVABLE_LINKS">[];
}) {
  return (
    <div className="grid grid-cols-2 justify-center gap-3 px-4 md:px-0">
      {images?.map((image, index) => (
        <div key={`ImageCollectionGrid-${image?.sys.id}-${index}`} className="">
          <Image
            src={`https:${image?.fields?.image?.fields?.file?.url}`}
            alt={image?.fields?.image?.fields?.description ?? ""}
            height={400}
            width={400}
            className="h-full w-full rounded-lg object-cover"
            loading="lazy"
          />
        </div>
      ))}
    </div>
  );
}
